module.exports = __webpack_public_path__ + "static/media/formulario.4e69ffc7.png";